import { render, staticRenderFns } from "./PetSelect.vue?vue&type=template&id=3024acca&scoped=true&"
import script from "./PetSelect.vue?vue&type=script&lang=js&"
export * from "./PetSelect.vue?vue&type=script&lang=js&"
import style0 from "./PetSelect.vue?vue&type=style&index=0&id=3024acca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3024acca",
  null
  
)

export default component.exports